import { Profilo } from "./profilo";
import { Trascodifica } from "./trascodifica";

export class Sconto {
  percentualeSconto: number;
  idProfilo: number;
  profilo: Profilo;
  idTipologiaProfilo: number;
  tipologiaProfilo: Trascodifica;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/sconto.ts